import { render } from "./IconBase.ce.vue?vue&type=template&id=e9e56da6"
import script from "./IconBase.ce.vue?vue&type=script&lang=js"
export * from "./IconBase.ce.vue?vue&type=script&lang=js"

import _style_0 from "./IconBase.ce.vue?vue&type=style&index=0&id=e9e56da6&inline&lang=scss"

import exportComponent from "/builds/govbr-ds/wbc/govbr-ds-wbc/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__